import { Col, Row, Typography } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import { TwoLinesSeparator } from '../../../components/layout/layoutElements';
import { cssVariables } from '../../../styles/cssVariables';
import { useQuoteStyles } from '../../../styles/quote.styles';
import {
  DeliveryDurationColumn,
  DeliveryTimeColumn,
  DirectDriveIcon,
  DriveMileageColumn,
  DriveTypeColumn,
} from '../../../components/quotes/QuoteRoutingContent';
import { calculateDuration } from '../../../common/utils/dateUtils';
import { DeliveryStatus } from './QuoteDeliveryStatus';

export function QuoteDriveItinerary({ quote }) {
  const { styles: sharedStyles } = useQuoteStyles();
  const departure = moment(quote?.pickupDateTime?.scheduled);
  const delivery = moment(quote?.deliveryDateTime?.scheduled);
  const duration = calculateDuration(
    moment(departure).tz(quote?.origin?.timezone, true),
    moment(delivery).tz(quote?.destination?.timezone, true)
  );

  return (
    <div>
      <TwoLinesSeparator
        style={{
          marginTop: cssVariables.spaceLg,
          marginBottom: cssVariables.spaceSm,
        }}
      />
      <Row>
        <Typography.Title
          level={3}
          className={classNames(
            'text-uppercase',
            sharedStyles.shipmentInfoTitle
          )}
        >
          <FormattedMessage id="book.newQuote.driveItinerary" />
        </Typography.Title>
      </Row>
      <Row>
        <DeliveryStatus className="hide-sm-and-smaller" />
      </Row>
      <Row justify="space-between">
        <Col span={5}>
          <DirectDriveIcon />
        </Col>
        <Col span={5} md={5}>
          <DeliveryTimeColumn
            label="book.newQuote.driveTime"
            departure={departure}
            departureTimezone={quote.origin.timezone}
            arrival={delivery}
            arrivalTimezone={quote.destination.timezone}
          />
        </Col>
        <Col span={3} md={5}>
          <DeliveryDurationColumn
            label="book.newQuote.driveDuration"
            duration={duration}
          />
        </Col>
        <Col span={3} md={4}>
          <DriveMileageColumn distance={quote?.origin?.localMileage} />
        </Col>
        <Col span={3} md={5}>
          <DriveTypeColumn />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <TwoLinesSeparator />
        </Col>
      </Row>
    </div>
  );
}
